module.exports = __webpack_public_path__ + "img/balatonszemes.58794f40.jpg";